import { Injectable } from '@angular/core';
import {
  Action,
  State,
  Selector,
  StateContext
} from '@ngxs/store';
import { patch } from '@ngxs/store/operators'
import { BalloonStateActions } from './balloon-state.actions';
import { BalloonStateModel } from './balloon-state.models';
import { DbrBalloonEntity } from '@balloon-race-fullstack-monorepo/dbr-rest-api';

const STATE_NAME = 'BalloonState';

@State<BalloonStateModel>({
  name: STATE_NAME,
  defaults: {
    activeBalloon: null,
  },
})
@Injectable()
export class BalloonState {
  @Selector()
  static activeBalloon(state: BalloonStateModel): DbrBalloonEntity | null {
    return state.activeBalloon;
  }

  @Action(BalloonStateActions.SetActiveBalloon)
  setActiveBalloon(ctx: StateContext<BalloonStateModel>, action: BalloonStateActions.SetActiveBalloon) {
    ctx.setState(patch<BalloonStateModel>({
      activeBalloon: action.balloon
    }));
  }

}

